import { Logger } from '../../../core/helpers/logger.ts';

export function clickProductEventHandler(payload: { productLink?: string; type?: 'similar' }) {
  const { productLink } = payload || {};
  if (!productLink) {
    Logger.warn('Product link is not available.');
    return;
  }

  window.open(productLink, '_self');
}
